import { institutionalApi } from "./index";
import { transformErrorResponse } from "../../utils";
import { RFIType } from "interfaces/enums";

export const rfiApi = institutionalApi.injectEndpoints({
  endpoints: (builder) => ({
    getRFIDocument: builder.query<string, { rfi_id: string }>({
      query: (params) => ({
        url: `/rfi/document`,
        method: "GET",
        params: { rfi_id: params.rfi_id },
      }),
      transformErrorResponse,
    }),
    createRFI: builder.mutation<
      string,
      {
        document_title: string;
        document_description?: string;
        document_type: RFIType;
        decider_id: string;
        kyb_id?: string;
        destination_account_id?: string;
        language: string;
        order_router_id?: string;
      }
    >({
      query: (body) => ({
        url: `/rfi/create`,
        method: "POST",
        body,
      }),
      invalidatesTags: ["Onboardings", "AdminDestinationAccounts"],
      transformErrorResponse,
    }),
    approveRFI: builder.mutation<
      string,
      { rfi_id: string; approval: boolean; approval_details?: string }
    >({
      query: (body) => ({
        url: `/rfi/approval/${body.rfi_id}`,
        method: "POST",
        body,
      }),
      invalidatesTags: [
        "Onboardings",
        "AdminDestinationAccounts",
        "RouterAccounts",
        "RouterSubAccounts",
      ],
      transformErrorResponse,
    }),
  }),
});

export const {
  useLazyGetRFIDocumentQuery,
  useCreateRFIMutation,
  useApproveRFIMutation,
} = rfiApi;
